// generated by genversion
export const version = '1.7.3';
//# sourceMappingURL=version.js.map